export enum FlowsLaunchDarklyFeatureFlags {
  ROUTING_INFORMATION = 'match-flow-routing-information',
  MATCH_FLOW_SLUG = 'match-flow-slug',
}
